const messages = {
  en: {
    joinTitle: "Enter the code",
    joinHint: "Type the short code shown on the screen.",
    codeLabel: "Short code",
    joinButton: "Join",
    storageBlocked:
      "This browser is blocking local storage. You can continue online, but please open this page in Safari or Chrome for a more reliable session.",
    consentContinue: "I agree — continue",
    start: "Start",
    startClosed: "The start window is closed.",
    waitingStart: "Waiting for the start window…",
    next: "Next",
    previous: "Previous",
    caseInformation: "Case information",
    submitDecision: "Submit decision",
    confirmSubmit: "Confirm submit",
    keepEditing: "Keep editing",
    submitIrreversible:
      "Once you submit, you cannot change your answer and you will proceed to the next stage.",
    justification: "Justification",
    chars: "characters",
    previousAnswer: "Previous decision",
    sessionEnded: "Session ended",
    offline: "You are offline. Answers are saved on this device and will sync when you reconnect.",
    leaveWarn: "You have an active session. Are you sure you want to leave?",
    confidence: "Mark how confident you are in this decision.",
    confidenceScale: "1 = not at all confident, 7 = completely confident.",
    confidenceLow: "1 — not at all confident",
    confidenceHigh: "7 — completely confident",
    surveyTitle: "Short survey",
    surveySubmit: "Submit",
    advanceStuck: "Could not continue automatically. Tap Continue to try again.",
    continue: "Continue",
  },
};

export type Locale = keyof typeof messages;
export const t = (key: keyof (typeof messages)["en"], locale: Locale = "en") =>
  messages[locale][key] ?? messages.en[key];
